import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Formik, Field } from 'formik';
import Button from 'react-bootstrap/Button';
import localforage from 'localforage';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import * as OrderActions from 'bv360/redux/actions/orders';
import validationSchema from './validationSchema';
import { URLS } from 'bv360/utils/urls';

import PhoneField from 'shared/components/form/fields/phone';
import TextField from 'shared/components/form/fields/text';
import * as Yup from 'yup';
import { SmsConsentText, VerifyMethodField, useQuickSignSmsEnabled } from './sms-consent';

export default ({ error, executeRecaptcha, setQsValues, smsPending, uuid }) => {
  const dispatch = useDispatch();
  const smsEnabled = useQuickSignSmsEnabled();
  const schema = smsEnabled
    ? validationSchema.shape({ verifyMethod: Yup.string().required('Required') })
    : validationSchema;
  const location = useLocation();

  const goToLogin = async () => {
    await localforage.setItem('redirect', location.pathname);
    window.location.href = URLS.LOGIN;
  };

  return (
    <Formik
      displayName={'VerifyQuickSignDetails'}
      onSubmit={async formVals => {
        const vals = { ...formVals, verifyBySms: smsEnabled && formVals.verifyMethod === 'sms' };
        dispatch(
          OrderActions.sendSmsCode({
            ...vals,
            uuid
          })
        );
        setQsValues({ ...vals, uuid });
      }}
      initialValues={{
        initiator: { first_name: '', last_name: '' },
        verifyMethod: '',
        verifyBySms: false
      }}
      validationSchema={schema}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={true}
    >
      {({ setFieldValue, submitForm, errors, isValid }) => (
        <form>
          <Row className="form-group">
            <Col md={3}>
              <Button onClick={goToLogin}>Sign in</Button>
            </Col>
          </Row>

          <Row>
            <Col md={1} style={{ textAlign: 'center' }}>
              <strong>Or</strong>
            </Col>
            <Col md={11}>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                <em>Please complete the following information to verify your identity:</em>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="form-group">
              <Field
                label="Your First Name*"
                maxLength={32}
                name="initiator.first_name"
                disabled={smsPending}
                component={TextField}
              />
            </Col>
            <Col md={3} className="form-group">
              <Field
                label="Your Last Name*"
                maxLength={32}
                name="initiator.last_name"
                disabled={smsPending}
                component={TextField}
              />
            </Col>
            <Col md={3} className="form-group">
              <Field
                label="Your Mobile Number*"
                maxLength={32}
                name="phone"
                placeholder="(555) 555-5555"
                disabled={smsPending}
                component={PhoneField}
                showValidation
              />
            </Col>
            <Col md={3} className="form-group">
              <Field
                label="Provider Office Zip*"
                maxLength={5}
                name="officeZip"
                disabled={smsPending}
                component={TextField}
              />
            </Col>
          </Row>
          {smsEnabled && (
            <Row>
              <Col md={12} className="form-group">
                <VerifyMethodField disabled={smsPending} />
              </Col>
            </Row>
          )}
          <Row className="form-group">
            <Col md={10}>
              {smsEnabled && <SmsConsentText />}
              {error && (
                <span className="has-error">
                  <i className="fa fa-exclamation-triangle fa-fw has-error" />
                  {error}
                </span>
              )}
            </Col>
            <Col md={2}>
              <Button
                type="button"
                disabled={!isValid || smsPending}
                onClick={async () => {
                  const recaptchaToken = await executeRecaptcha('quick_sign');
                  setFieldValue('recaptchaToken', recaptchaToken, true);
                  submitForm();
                }}
                className="float-end"
                style={{ minWidth: 80 }}
              >
                <span style={{ display: 'inline-block', minWidth: 60 }}>
                  <i
                    className="fa fa-fw fa-circle-notch fa-spin"
                    style={{ display: smsPending ? 'inline-block' : 'none' }}
                    aria-hidden="true"
                  />
                  <span style={{ display: smsPending ? 'none' : 'inline' }}>Submit</span>
                </span>
              </Button>
            </Col>
          </Row>
        </form>
      )}
    </Formik>
  );
};
